import { useCallback, useEffect, useRef } from 'react';
import { useId } from '../useId';
export var visuallyHiddenStyles = "\n  clip-path: inset(100%);\n  clip: rect(1px, 1px, 1px, 1px);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n";
/**
 * read announce when need read message.
 *
 * @example
 * ```ts
 *   const announce = useAnnouncer('simpleId');
 *
 *   announce(`You click "Announce" button`);
 * ```
 */
export var useAnnouncer = function (id) {
    var _id = useId(id ? "rc-announcer-" + id : 'rc-announcer', !id);
    var ref = useRef(null);
    useEffect(function () {
        var el = document.createElement('div');
        ref.current = el;
        el.id = _id;
        el.setAttribute('aria-live', 'assertive');
        el.setAttribute('aria-atomic', 'true');
        el.setAttribute('aria-hidden', 'false');
        el.setAttribute('style', visuallyHiddenStyles);
        document.body.appendChild(el);
        return function () {
            setTimeout(function () {
                var body = document.body;
                if (body.contains(el)) {
                    body.removeChild(el);
                }
                if (el === ref.current) {
                    ref.current = null;
                }
            });
        };
    }, [_id]);
    /** announce method, call with message that want let reader speak */
    var announce = useCallback(function (message) {
        var el = ref.current;
        if (el && message) {
            el.setAttribute('aria-hidden', 'false');
            el.textContent = message;
        }
    }, []);
    return announce;
};
